/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import DataProvider from "../../../services";
import {
  Button,
  DatePicker,
  FloatButton,
  Form,
  Input,
  Modal,
  notification,
} from "antd";
import { useParams } from "react-router-dom";
import { useAppStore } from "../../../store";
import LoadWrapper from "../../../components/elements/load-wrapper";
import Empty from "../../../components/elements/empty";
import { GiCheckMark } from "react-icons/gi";
import SelectPlan from "./select-plan";
import Pay from "./pay";
import Confirm from "./confirm";
import ChangePlan from "./change-plan";
import moment from "moment";
import ChatButton from "../../../components/cards/message-card/chatButton";
import ChatInterface from "../../../components/sections/chatai";
import whatsapp from "../../../assets/images/WhatsApp.png";
import kobi from "../../../assets/images/KUUL TRANS ROUND.png";

export default function Mcare(props: any) {
  const [nextofkinForm] = Form.useForm();
  const { setPlan, setState } = useAppStore();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentNextOfKin, setCurrentNextOfKin] = useState<any | null>(null);
  const params = useParams();
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState<boolean>(false);
  const [screen, setScreen] = useState<number>(0);
  const [subscription, setSubscription] = useState<any | null>(null);
  const [nextOfKinName, setNextOfKinName] = useState<string>("");
  const [nextOfKinContact, setNextOfKinContact] = useState<string>("");
  const [nextOfKinDob, setNextOfKinDob] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleEditNextOfKin = (nextOfKin: any) => {
    setCurrentNextOfKin(nextOfKin);
    nextofkinForm.setFieldsValue({
      name: nextOfKin.name,
      phoneNumber: nextOfKin.phoneNumber,
      dateOfBirth: moment(nextOfKin.dateOfBirth, "YYYY-MM-DD"),
    });
    setIsModalVisible(true);
  };

  const handleSaveNextOfKin = async () => {
    try {
      const values = await nextofkinForm.validateFields();
      const subscriptionId = subscription?.id;
      const nextOfKinId = currentNextOfKin?.id;

      if (!subscriptionId || !nextOfKinId) {
        throw new Error("Subscription ID or Next of Kin ID is missing.");
      }

      const updatedNextOfKinData = {
        name: values.name,
        phoneNumber: values.phoneNumber,
        dateOfBirth: moment(values.dateOfBirth).format("YYYY-MM-DD"),
      };

      setLoading(true);

      const response = await DataProvider.updateNextOfKin(
        updatedNextOfKinData,
        nextOfKinId
      );

      api.success({
        message: "Next of Kin Updated",
        description: "Next of Kin information updated successfully.",
      });

      setIsModalVisible(false);
      nextofkinForm.resetFields();
      setCurrentNextOfKin(null);
      window.location.reload();
    } catch (error: any) {
      api.error({
        message: "Update Failed",
        description:
          error.message || "An error occurred while updating Next of Kin.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setNextOfKinName("");
    setNextOfKinContact("");
    setNextOfKinDob("");
  }, []);

  const getSubscription = useCallback(async () => {
    setLoading(true);
    const { data } = await DataProvider.getUserSubscription();

    setSubscription(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (params.id === "2" && screen === 0) {
      getSubscription();
    }
  }, [params, getSubscription, screen]);

  return (
    <div>
      <div className="bg-white border border-solid border-gray-200 rounded-lg w-full min-h-[75vh] flex justify-center items-center py-3 px-3">
        {screen === 0 && (
          <LoadWrapper loading={loading}>
            {loading ? null : !loading &&
              subscription !== null &&
              subscription.status === "active" ? (
              <div className="w-full grid lg:grid-cols-5 gap-5 grid-cols-1">
                <div className="lg:col-span-2">
                  <div className="rounded-2xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                    <div className="px-5 py-4 bg-gradient-to-br from-[#1A94EC] to-[#0d7bc4] text-white">
                      <p className="text-xs uppercase tracking-wide opacity-80">
                        Your plan
                      </p>
                      <h2 className="text-xl font-bold mt-1">
                        {subscription.mcare.description}
                      </h2>
                      <p className="mt-2 text-2xl font-bold">
                        GH¢{subscription.mcare.price}
                        <span className="text-sm font-normal opacity-80">
                          /month
                        </span>
                      </p>
                    </div>
                    <div className="px-5 py-4 space-y-2.5">
                      <div className="flex justify-between text-sm">
                        <span className="text-neutral-600">
                          Membership number
                        </span>
                        <span className="font-medium text-neutral-900">
                          {subscription.code}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-neutral-600">Number</span>
                        <span className="font-medium text-neutral-900">
                          {subscription.msisdn}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-neutral-600">
                          Next billing date
                        </span>
                        <span className="font-medium text-neutral-900">
                          {subscription.endDate
                            ? moment(subscription.endDate).format(
                                "Do MMMM, YYYY"
                              )
                            : "Expired"}
                        </span>
                      </div>
                    </div>
                    <div className="px-5 pb-5 pt-1 border-t border-neutral-100">
                      <p className="text-xs font-semibold text-neutral-500 uppercase tracking-wide mb-2 mt-3">
                        What&apos;s included
                      </p>
                      <div className="space-y-3">
                        {subscription.mcare.offers.map(
                          (itx: any, idx: any) => (
                            <div key={idx}>
                              <p className="text-sm font-semibold text-neutral-800 mb-1">
                                {itx.name}
                              </p>
                              <ul className="space-y-1">
                                {itx.list.map((i: any, idxx: any) => (
                                  <li
                                    key={idxx}
                                    className="flex items-start gap-2 text-sm text-neutral-600"
                                  >
                                    <GiCheckMark
                                      size={14}
                                      className="text-[#1A94EC] mt-0.5 shrink-0"
                                    />
                                    <span>{i}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3 mt-4">
                    {subscription.status !== "active" && (
                      <Button
                        onClick={() => {
                          setState("RENEW");
                          setPlan(subscription.mcare);
                          setScreen(2);
                        }}
                        size="large"
                        style={{ backgroundColor: "#1A94EC", color: "white" }}
                        className="w-full sm:flex-1"
                      >
                        Renew your plan
                      </Button>
                    )}
                    <Button
                      onClick={() => {
                        setState("CHANGE");
                        setScreen(4);
                      }}
                      size="large"
                      className="w-full sm:flex-1"
                    >
                      Change Plan
                    </Button>
                  </div>
                </div>

                <div className="lg:col-span-3">
                  <div className="rounded-2xl border border-neutral-200 bg-white shadow-sm p-5 sm:p-6">
                    {subscription?.nextOfKin ? (
                      <>
                        <h3 className="text-lg font-semibold mb-4 text-neutral-900">
                          Next of Kin Details
                        </h3>
                        <div className="space-y-2.5">
                          <div className="flex justify-between text-sm">
                            <span className="text-neutral-600">Name</span>
                            <span className="font-medium text-neutral-900">
                              {subscription.nextOfKin.name}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-neutral-600">
                              Contact number
                            </span>
                            <span className="font-medium text-neutral-900">
                              {subscription.nextOfKin.phoneNumber}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm">
                            <span className="text-neutral-600">
                              Date of birth
                            </span>
                            <span className="font-medium text-neutral-900">
                              {subscription.nextOfKin.dateOfBirth}
                            </span>
                          </div>
                        </div>
                        <div className="flex justify-end mt-5">
                          <Button
                            type="primary"
                            style={{ backgroundColor: "#1A94EC" }}
                            onClick={() =>
                              handleEditNextOfKin(subscription.nextOfKin)
                            }
                          >
                            Edit
                          </Button>
                        </div>
                      </>
                    ) : (
                      <>
                        <h3 className="text-lg font-semibold mb-4 text-neutral-900">
                          Add Next of Kin
                        </h3>
                        <Form form={nextofkinForm} layout="vertical">
                          <Form.Item
                            label="Next of Kin Name"
                            name="name"
                            rules={[
                              {
                                required: true,
                                message: "Please enter the next of kin's name.",
                              },
                            ]}
                          >
                            <Input placeholder="Enter next of kin's name" />
                          </Form.Item>
                          <Form.Item
                            label="Next of Kin Contact"
                            name="phoneNumber"
                            rules={[
                              {
                                required: true,
                                message: "Please enter a contact number.",
                              },
                            ]}
                          >
                            <Input placeholder="Enter next of kin's contact number" />
                          </Form.Item>
                          <Form.Item
                            label="Next of Kin Date of Birth"
                            name="dateOfBirth"
                            rules={[
                              {
                                required: true,
                                message: "Please select a date of birth.",
                              },
                            ]}
                          >
                            <DatePicker style={{ width: "100%" }} />
                          </Form.Item>
                          <Button
                            onClick={handleSaveNextOfKin}
                            size="large"
                            type="primary"
                            loading={loading}
                            style={{ backgroundColor: "#1A94EC" }}
                            className="w-full text-white"
                          >
                            Save Next of Kin
                          </Button>
                        </Form>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : subscription &&
              (subscription.status === "pending" ||
                subscription.status === "ActivationFailed") ? (
              <Empty
                imageStyle="md:h-44 h-24"
                titleStyle="md:text-lg text-sm"
                desStyle="md:text-base"
                title="Mcare"
                buttons={[
                  {
                    name: "Refresh",
                    event: () => getSubscription(),
                  },
                  {
                    name: "Subscribe",
                    type: "primary",
                    event: () => {
                      setState("SUB");
                      setScreen(1);
                    },
                  },
                ]}
                description="You are not on any active plan. Complete payment or Subscribe to a new package."
              />
            ) : subscription && subscription.status === "expired" ? (
              <Empty
                imageStyle="md:h-44 h-24"
                titleStyle="md:text-lg text-sm"
                desStyle="md:text-base"
                title="Mcare"
                buttons={[
                  {
                    name: "Refresh",
                    event: () => getSubscription(),
                  },
                  {
                    name: `Renew ${subscription.mcare.description}`,
                    type: "primary",
                    event: () => {
                      setState("RENEW");
                      setPlan(subscription.mcare);
                      setScreen(2);
                    },
                  },
                  {
                    name: "Change Plan",
                    type: "primary",
                    event: () => {
                      setPlan(subscription.mcare);
                      setState("CHANGE");
                      setScreen(1);
                    },
                  },
                ]}
                description="Your subscription is expired."
              />
            ) : subscription && subscription.status === "cancelled" ? (
              <Empty
                imageStyle="md:h-44 h-24"
                titleStyle="md:text-lg text-sm"
                desStyle="md:text-base"
                title="Mcare"
                buttons={[
                  {
                    name: "Refresh",
                    event: () => getSubscription(),
                  },
                  {
                    name: "Subscribe",
                    type: "primary",
                    event: () => {
                      setState("SUB");
                      setScreen(1);
                    },
                  },
                ]}
                description="You are not subscribed to any package. Kindly subscribe."
              />
            ) : (
              <Empty
                imageStyle="md:h-44 h-24"
                titleStyle="md:text-lg text-sm"
                desStyle="md:text-base"
                title="Mcare"
                buttons={[
                  {
                    name: "Refresh",
                    event: () => getSubscription(),
                  },
                  {
                    name: "Subscribe",
                    type: "primary",
                    event: () => {
                      setState("SUB");
                      setScreen(1);
                    },
                  },
                ]}
                description="You are not on any active plan."
              />
            )}
          </LoadWrapper>
        )}
        {screen === 1 && <SelectPlan screen={screen} setScreen={setScreen} />}
        {screen === 2 && <Pay screen={screen} setScreen={setScreen} />}
        {screen === 3 && <Confirm screen={screen} setScreen={setScreen} />}
        {screen === 4 && <ChangePlan screen={screen} setScreen={setScreen} />}

        <ChatButton />

        {isChatOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[10000]">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative">
              <button
                onClick={() => setIsChatOpen(false)}
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              >
                ✖
              </button>
              <ChatInterface />
            </div>
          </div>
        )}

        <div className="fixed bottom-10 -right-2 z-[9999] transform scale-150 flex items-center ">
          <FloatButton.Group
            trigger="click"
            type="default"
            style={{ insetInlineEnd: 24 }}
            icon={
              <img
                src={whatsapp}
                alt="WhatsApp"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            }
          >
            <FloatButton
              icon={
                <img
                  src={whatsapp}
                  alt="WhatsApp"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              }
              onClick={() =>
                window.open(
                  "https://wa.me/233555061412?text=Hello%20Medpharma%20Team%2C%20I%20need%20assistance",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            />
            <FloatButton
              icon={<img src={kobi} alt="kobikull" />}
              // description="Ask Kobikuul, your health bot"

              onClick={() => setIsChatOpen(true)}
            />
          </FloatButton.Group>
        </div>
      </div>

      <Modal
        title="Edit Next of Kin"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleSaveNextOfKin}
        confirmLoading={loading}
        okText="Update"
        width={600}
      >
        <Form form={nextofkinForm} layout="vertical">
          <Form.Item
            label="Next of Kin Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter the next of kin's name.",
              },
            ]}
          >
            <Input placeholder="Enter next of kin's name" />
          </Form.Item>
          <Form.Item
            label="Next of Kin Contact"
            name="phoneNumber"
            rules={[
              {
                required: true,
                message: "Please enter a contact number.",
              },
            ]}
          >
            <Input placeholder="Enter next of kin's contact number" />
          </Form.Item>
          <Form.Item
            label="Next of Kin Date of Birth"
            name="dateOfBirth"
            rules={[
              {
                required: true,
                message: "Please select a date of birth.",
              },
            ]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
      {contextHolder}
    </div>
  );
}
